import {
  Box,
  StyledTileButton,
  Typography,
  useButtonSelect,
} from "@braintrust/braintrust-ui-components";

import style from "./style.module.scss";

type ProjectDurationTileButtonProps = {
  value: string;
  onChange: (value: string | null) => void;
};

export const ProjectDurationTileButton = ({
  value,
  onChange,
}: ProjectDurationTileButtonProps) => {
  const {
    isSelected,
    handleChange,
    containerA11yProps,
    getItemKey,
    itemA11yProps,
  } = useButtonSelect({
    value,
    onChange,
  });

  return (
    <Box sx={{ display: "inline-block" }}>
      <Box
        {...containerA11yProps}
        sx={{ display: "flex", flexWrap: "wrap", m: -1.75 }}
      >
        {options.map((option, index) => {
          const _isSelected = isSelected(option);

          return (
            <Box
              key={getItemKey(option, index)}
              className={style.buttonTileDurationShadow}
              sx={{ width: 180, m: 1.75 }}
            >
              <StyledTileButton
                {...itemA11yProps(_isSelected)}
                variant="white-violet"
                isSelected={_isSelected}
                className={style.buttonTileDuration}
                onClick={(ev) => {
                  ev.preventDefault();
                  handleChange(option);
                }}
              >
                <Box
                  sx={{
                    pt: 3,
                    pb: "20px",
                    px: "20px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  {option.text && (
                    <Box style={{ fontSize: 20 }}>{option.text || ""}</Box>
                  )}
                  {option.label}
                </Box>
              </StyledTileButton>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

type TileLabelProps = {
  header: string;
  subtext: string;
};

const TileLabel = ({ header, subtext }: TileLabelProps) => {
  return (
    <>
      <Typography component="p" variant="label" size="large">
        {header}
      </Typography>
      <Typography component="p" variant="paragraph" size="small">
        {subtext}
      </Typography>
    </>
  );
};

const options = [
  {
    label: (
      <TileLabel
        header={ENUMS.JobContractTypeLabels.short}
        subtext="1-6 months"
      />
    ),
    value: ENUMS.JobContractType.SHORT,
    text: "⚡️",
  },
  {
    label: (
      <TileLabel
        header={ENUMS.JobContractTypeLabels.long}
        subtext="6 months or more"
      />
    ),
    value: ENUMS.JobContractType.LONG,
    text: "⏳️",
  },
];
